/**
 * Format folder names to be human-readable
 * Converts MEDIA_&_PRESS to Media & Press
 */
export const formatFolderName = (name: string): string => {
  if (!name) return name;

  // Replace underscores and hyphens with spaces
  let formatted = name.replace(/[_-]+/g, ' ').trim();

  // Split into words
  const words = formatted.split(' ');

  // Capitalize each word, with special handling for acronyms
  const acronyms = new Set([
    'CV',
    'ID',
    'USA',
    'US',
    'UK',
    'EU',
    'AI',
    'IT',
    'HR',
    'PR',
    'OCR',
    'PDF',
  ]);

  const capitalizedWords = words.map(word => {
    const upper = word.toUpperCase();
    // Keep known acronyms in uppercase
    if (acronyms.has(upper)) {
      return upper;
    }
    // Keep special characters as-is (like &)
    if (word === '&' || word.length === 1) {
      return word;
    }
    // Capitalize first letter of other words
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return capitalizedWords.join(' ');
};

/**
 * Format folder name with visa type handling
 */
export const formatFolderNameWithVisaTypes = (raw: string): string => {
  if (raw === 'All') return raw;

  let cleaned = raw.replace(/[_-]+/g, ' ').trim().toLowerCase();
  cleaned = cleaned.replace(/^visa\s+case\s+/, '');

  const visaMap: Record<string, string> = {
    'o 1a': 'O-1A',
    o1a: 'O-1A',
    o_1a: 'O-1A',
    'o-1a': 'O-1A',
    'o 1b': 'O-1B',
    o1b: 'O-1B',
    o_1b: 'O-1B',
    'o-1b': 'O-1B',
    'eb 1a': 'EB-1A',
    eb1a: 'EB-1A',
    eb_1a: 'EB-1A',
    'eb-1a': 'EB-1A',
    'eb 1b': 'EB-1B',
    eb1b: 'EB-1B',
    eb_1b: 'EB-1B',
    'eb-1b': 'EB-1B',
    'eb 1c': 'EB-1C',
    eb1c: 'EB-1C',
    eb_1c: 'EB-1C',
    'eb-1c': 'EB-1C',
    'eb 2 niw': 'EB-2-NIW',
    'eb2 niw': 'EB-2-NIW',
    'eb 2-niw': 'EB-2-NIW',
    'eb2-niw': 'EB-2-NIW',
    'eb-2-niw': 'EB-2-NIW',
    eb_2_niw: 'EB-2-NIW',
  };

  if (visaMap[cleaned]) return visaMap[cleaned];

  return formatFolderName(raw);
};
